import { render, staticRenderFns } from "./WarnResearch.vue?vue&type=template&id=e00d4234&scoped=true&"
import script from "./WarnResearch.vue?vue&type=script&lang=js&"
export * from "./WarnResearch.vue?vue&type=script&lang=js&"
import style0 from "./WarnResearch.vue?vue&type=style&index=0&id=e00d4234&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00d4234",
  null
  
)

export default component.exports